import { render, staticRenderFns } from "./jiejingdetail.vue?vue&type=template&id=0684edfc&scoped=true&"
import script from "./jiejingdetail.vue?vue&type=script&lang=js&"
export * from "./jiejingdetail.vue?vue&type=script&lang=js&"
import style0 from "./jiejingdetail.vue?vue&type=style&index=0&id=0684edfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0684edfc",
  null
  
)

export default component.exports